import { cn } from '@/lib/cn';

/**
 * Space held while a list reads from the database. Deliberately blank rather than a skeleton: the read is
 * usually a few milliseconds, and something that shimmers for one frame is more distracting than nothing.
 * The point is only that the screen must not claim to be empty before it knows.
 */
export const ListLoading = ({ className }: { className?: string }) => (
  <div role="status" aria-label="Loading" className={cn('min-h-[120px]', className)} />
);
